import React from "react";
import { twMerge } from "tailwind-merge";
import { buttonSizes } from "../../design/tokens.js";

const variants = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  danger: "btn-danger",
  ghost: "btn-ghost",
  /** Kein Variant-Fill — z. B. Kalender-Eventkarten mit eigenen Tailwind-Typklassen */
  bare: "",
  success: "btn-success",
  violet: "btn-violet",
};

const AppButton = React.forwardRef(function AppButton(
  {
    children,
    variant = "secondary",
    size = "md",
    className = "",
    type = "button",
    style,
    ...props
  },
  ref
) {
  const usesSegmentClasses =
    typeof className === "string" &&
    /\bseg-btn-(idle|active-primary|active-success)\b/.test(className);
  const colorClasses = usesSegmentClasses
    ? ""
    : (variants[variant] ?? variants.secondary);
  const sizeClasses = buttonSizes[size] || buttonSizes.md;

  return (
    <button
      ref={ref}
      type={type}
      className={twMerge(
        "wrtk-btn inline-flex items-center justify-center gap-2 rounded-lg border font-medium transition-colors duration-150 disabled:opacity-55 disabled:cursor-not-allowed focus-ring",
        sizeClasses,
        colorClasses,
        className
      )}
      style={usesSegmentClasses ? { ...style } : { ...style }}
      {...props}
    >
      {children}
    </button>
  );
});

export default AppButton;
